/**
 * @type Function
 * @description Checking if the page was resized vertically. Preventing events firing on mobile devices when the address bar is shown/hidden.
 */

export let isVerticalResize = false

const verticalResizeCheck = {
  init(): void {
    let lastWindowHeight = window.innerHeight
    let lastWindowWidth = window.innerWidth

    window.addEventListener('resize', () => {
      const currentHeight = window.innerHeight
      const currentWidth = window.innerWidth
      isVerticalResize = currentHeight !== lastWindowHeight && currentWidth === lastWindowWidth

      lastWindowHeight = currentHeight
      lastWindowWidth = currentWidth
    })
  },
}

export default verticalResizeCheck
